import type { QueryApi } from "../../api/query";

export function createUseProjectSupporters($api: QueryApi) {
  return function useProjectSupporters(params: { projectId: string; page?: number; size?: number }) {
    return $api.useQuery(
      "get",
      "/projects/{id}/supporters",
      {
        params: {
          path: { id: params.projectId },
          query: { pageable: { page: params.page ?? 0, size: params.size ?? 10 } },
        },
      },
      { enabled: !!params.projectId, staleTime: 2 * 60_000 },
    );
  };
}
